import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
import useTeamIconSpecs from './useTeamMarkerSpecs';
import CarIcon from '../CarIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TeamMarker',
    props: {
        team: {
            type: Object,
            required: true,
        },
    },
    setup: function (__props) {
        var props = __props;
        var teamIconSpecs = computed(function () { return useTeamIconSpecs(props.team); });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(CarIcon, {
                    "fill-color": teamIconSpecs.value.fill.color,
                    "outline-color": teamIconSpecs.value.outline.color,
                    "highlight-outline": teamIconSpecs.value.outline.highlight,
                    label: teamIconSpecs.value.label.text,
                    "label-color": teamIconSpecs.value.label.color,
                    "is-electric": __props.team.vehicleElectrical
                }, null, 8 /* PROPS */, ["fill-color", "outline-color", "highlight-outline", "label", "label-color", "is-electric"]),
                _renderSlot(_ctx.$slots, "default")
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
